/* SkMoney (2026-09-15): formátování ceny v JS IDENTICKÉ s Liquid filtrem money aktuálního requestu.
   Formát se neodhaduje z Intl ani z money_format — odvozuje se ze vzorku {{ 123456789 | money }},
   který vyrenderuje Liquid (snippet sk-money-config): prefix/sufix, oddělovač tisíců, desetinná
   čárka/tečka a počet desetin. Dřív Intl s maximumFractionDigits:0 ukazoval €155,50 jako „156 €"
   a HUF „51 190 Ft" místo „51.190 Ft". Nečíselný vstup → prázdný řetězec (nikdy „NaN Kč"). */
(function (root) {
	function stripTags(s) {
		return String(s == null ? '' : s).replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '\u00a0').replace(/&amp;/g, '&').replace(/&euro;/g, '\u20ac');
	}
	function parseSample(sample) {
		var txt = stripTags(sample);
		var m = /\d[\d.,'\u00a0\u202f ]*\d/.exec(txt);
		if (!m) return null;
		var num = m[0];
		var cfg = { prefix: txt.slice(0, m.index), suffix: txt.slice(m.index + num.length), dec: '', frac: 0, thou: '' };
		var intPart = num;
		var dm = /([.,])(\d{2})$/.exec(num);
		if (dm && dm[2] === '89') { cfg.dec = dm[1]; cfg.frac = 2; intPart = num.slice(0, -3); }
		var tm = /\d([^\d])\d{3}$/.exec(intPart);
		cfg.thou = tm ? tm[1] : '';
		var digits = intPart.replace(/\D/g, '');
		if (digits !== (cfg.frac === 2 ? '1234567' : '1234568')) return null;
		return cfg;
	}
	function formatWith(cfg, amount, whole) {
		var n = typeof amount === 'string' ? Number(amount) : amount;
		if (typeof n !== 'number' || !isFinite(n)) return '';
		var cents = Math.round(n * 100);
		var neg = cents < 0;
		if (neg) cents = -cents;
		var intVal;
		var fracStr = '';
		if (cfg.frac === 2 && !whole) {
			intVal = Math.floor(cents / 100);
			var c = cents % 100;
			fracStr = cfg.dec + (c < 10 ? '0' : '') + c;
		} else {
			intVal = Math.floor((cents + 50) / 100);
		}
		var s = String(intVal).replace(/\B(?=(\d{3})+(?!\d))/g, cfg.thou);
		return (neg ? '-' : '') + cfg.prefix + s + fracStr + cfg.suffix;
	}
	function create(sample) {
		var cfg = parseSample(sample);
		return {
			ok: !!cfg,
			format: function (amount) { return cfg ? formatWith(cfg, amount, false) : ''; },
			formatWhole: function (amount) { return cfg ? formatWith(cfg, amount, true) : ''; }
		};
	}
	/* Nejlevnější varianta produktu z datasetu api-filter (= Liquid product.price). Shoda → první v pořadí.
	   Cena i compare-at se berou z TÉŽE varianty. Bez platné ceny → null (karta bez ceny, ne „0 Kč"). */
	function cheapestVariant(p) {
		if (!p || !Array.isArray(p.var)) return null;
		var best = null;
		for (var i = 0; i < p.var.length; i++) {
			var v = p.var[i];
			if (v && typeof v.p === 'number' && isFinite(v.p) && (best === null || v.p < best.p)) best = v;
		}
		return best;
	}
	var api = { parseSample: parseSample, formatWith: formatWith, create: create, cheapestVariant: cheapestVariant };
	if (typeof module !== 'undefined' && module.exports) module.exports = api;
	if (root) {
		root.SkMoneyLib = api;
		var sample = root.SkMoneyConfig && root.SkMoneyConfig.sample;
		if (sample != null) {
			var inst = create(sample);
			if (inst.ok) {
				root.SkMoney = { format: inst.format, formatWhole: inst.formatWhole, cheapestVariant: cheapestVariant };
			} else {
				console.warn('SkMoney: vzorek ceny se nepodařilo rozpoznat, použije se záloha', sample);
			}
		}
	}
})(typeof window !== 'undefined' ? window : null);
